import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, zone }) =>
    present(
      repository
        .saveZone(planzone, zone)
        .then((savedZone) => ({ planzone, zone: savedZone }))
        .catch((error) => Promise.reject({ error, planzone, zone })),
    );
}

export type { Interactor };

export { createInteractor };
